






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class Rotate360 extends Vue {

}
